import { boot } from 'quasar/wrappers'
import mask from '../functions/mask'

export default boot(({ app }) => {
	app.config.globalProperties.$mask = mask
})
